import React, { useState, useEffect, useRef } from 'react'
import { Snackbar, CircularProgress } from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import dayjs from 'dayjs'
import LogoP1 from '../../../../assets/images/logomain.png'
import useInvoiceBillStyles from './styles'
import '../../businessview-style.scss'
import axios from 'axios'
import InvoiceTable from './components/InvoiceTable'
import OutstandingPaymentsTable from './components/OutstandingPaymentsTable '
import FaultSummaryTable from './components/FaultSummaryTable'
import FaultEventsTable from './components/FaultEventsTable'
import EmailDialog from './components/EmailDialog'
// import useEmailSettings from '../../../../hooks/useEmailSettings'
import AutoReminderDialog from './components/AutoReminderDialog'
import ExportZohoDialog from './components/ExportZohoDialog'
import ActionButtons from './components/ActionButtons'
import emailTemplate from './utils/emailTemplate'
import { generatePDF } from './utils/pdfGenerator'
import {
  getLastInvoiceNumber,
  updateInvoicestatus,
  updateMultipleFields,
  recordEmailStatus,
  updateInvoiceEmailStatus,
} from './utils/invoiceApi'
import processInvoiceData from './utils/processInvoiceData '
import moment from 'moment'
import { exportToZoho, getZohoInvoiceDetails } from './utils/ZohoApis'
import { expressURL,BREVO_API_KEY } from '../../../../services/api'
import {
  fetchBillingRecordByPlantAndMonth,
  updateBillingRecordWithInvoice,
  syncBillingRecordFromInvoice,
} from '../../../../services/billingRecords.service'


const SENDER_EMAIL = 'info@de.energy'
// Default sender name used when no organization/zoho name is available
const DEFAULT_SENDER_NAME = 'Distributed Energy'
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const InvoiceBill = ({
  DeemedlogData,
  invoiceReportList,
  state,
  invoiceDate,
  zohoState,
}) => {
  const classes = useInvoiceBillStyles()
  const [isLoading, setIsLoading] = useState(true)
  const [isDownloading, setIsDownloading] = useState(false)
  const [mainEnergy, setMainEnergy] = useState(0)

  const [omAmounts, setOmAmounts] = useState(0)
  const [accountableFailure, setAccountableFailure] = useState(0)
  const [faultEvents, setFaultEvents] = useState({
    GridFailure: 0,
    InverterFailure: 0,
    Manuallyinverterbreakerturnedoff: 0,
    VoltageFluctuations: 0,
    RelayFailureMCCBFailure: 0,
    AnyOtherFault: 0,
    CableTerminationIssue: 0,
  })
  // Initialize with last day of the selected billing month (invoiceDate prop)
  const getDefaultInvoiceDate = () => {
    if (!invoiceDate) return new Date().toISOString().split('T')[0]
    // Parse the billing month and set to last day of that month
    const billingDate = dayjs(invoiceDate)
    return billingDate.endOf('month').format('YYYY-MM-DD')
  }
  
  const [firstDate, setFirstDate] = useState(getDefaultInvoiceDate())
  const [dateloed, setDateLoed] = useState(false)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [faultSummary, setFaultSummary] = useState([])
  const [outstandingPayments, setOutstandingPayments] = useState([])
  const [editingPaymentId, setEditingPaymentId] = useState(null)
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
  const [emailType, setEmailType] = useState('')
  const [autoReminderDialogOpen, setAutoReminderDialogOpen] = useState(false)
  const [exportZohoDialogOpen, setExportZohoDialogOpen] = useState(false)
  const [pendingAutoReminderStatus, setPendingAutoReminderStatus] =
    useState(false)
  const [emailDialogData, setEmailDialogData] = useState({
    toEmails: [],
    ccEmails: [],
    isLoading: false,
    error: null,
  })

  const handleEmailButtonClick = async (type) => {
    setEmailType(type)
    setEmailDialogData((prev) => ({ ...prev, isLoading: true, error: null }))

    try {
      if (type === 'team') {
        // Fetch team emails directly from the API
        const response = await fetch(`${expressURL}/api/email-settings/invoice`);
        if (!response.ok) {
          throw new Error('Failed to fetch team email settings');
        }
        const data = await response.json();
        console.log("team invoice", data);
        
        // Extract and validate team emails
        const teamToEmails = data.to?.map(recipient => recipient.email).filter(email => email && typeof email === 'string') || [];
        const teamCcEmails = data.cc?.map(recipient => recipient.email).filter(email => email && typeof email === 'string') || [];
        
        console.log('Processed team TO emails:', teamToEmails);
        console.log('Processed team CC emails:', teamCcEmails);

        if (teamToEmails.length === 0 && teamCcEmails.length === 0) {
          throw new Error('No valid team email recipients found');
        }

        setEmailDialogData((prev) => ({
          ...prev,
          toEmails: teamToEmails,
          ccEmails: teamCcEmails,
          isLoading: false,
        }));
      } else {
        console.log('Fetching customer email', state?.data?.entity?.email)
        console.log('Fetching customer ccEmail', state?.data?.entity?.ccEmail)

        // Handle customer emails from client details
        // First, extract the raw email data
        const rawToEmails = state?.data?.entity?.email;
        const rawCcEmails = state?.data?.entity?.ccEmail;

        // Convert to arrays and clean up
        let clientEmails = [];
        if (Array.isArray(rawToEmails)) {
            clientEmails = rawToEmails.filter(email => email && typeof email === 'string');
        } else if (rawToEmails && typeof rawToEmails === 'string') {
            clientEmails = [rawToEmails];
        }

        let clientCCEmails = [];
        if (Array.isArray(rawCcEmails)) {
            clientCCEmails = rawCcEmails.filter(email => email && typeof email === 'string');
        } else if (rawCcEmails && typeof rawCcEmails === 'string') {
            clientCCEmails = [rawCcEmails];
        }

        console.log('Final processed customer emails:', clientEmails);
        console.log('Final processed CC emails:', clientCCEmails);

        if (clientEmails.length === 0 && clientCCEmails.length === 0) {
          throw new Error('No valid email recipients found');
        }

        setEmailDialogData((prev) => ({
          ...prev,
          toEmails: clientEmails,
          ccEmails: clientCCEmails,
          isLoading: false,
        }))
      }
    } catch (error) {
      console.error('Error in email handling:', error)
      setEmailDialogData((prev) => ({
        ...prev,
        error: error.message,
        isLoading: false,
      }))
    }

    setConfirmDialogOpen(true)
  }
  const [printMode, setPrintMode] = useState(false)
  const [invoiceDetails, setInvoiceDetails] = useState(null)
  const [zohoConnected, setZohoConnected] = useState(false)
  const [zohoinvoicenumber, setzohoinvoicenumber] = useState('')
  const [processingButton, setProcessingButton] = useState(null) // null, 'emailTeam', 'emailCustomer', 'saveDownload', 'exportZoho'
  const [dueDate, setDueDate] = useState(null)
  const [autoGenerate, setAutoGenerate] = useState(false)
  const [automated, setAutomated] = useState(false)
  const [createdAt, setCreatedAt] = useState(null)
  const [updatedAt, setUpdatedAt] = useState(null)

  const [emailStatus, setEmailStatus] = useState({
    open: false,
    message: '',
    severity: 'success',
  })

  // Debug: log emailStatus changes to help diagnose snackbar visibility
  useEffect(() => {
    console.log('emailStatus changed:', emailStatus)
  }, [emailStatus])

  const [saveStatus, setSaveStatus] = useState({
    open: false,
    message: '',
    severity: 'success',
  })

  // Add these states in the InvoiceBill component
  const [isSaving, setIsSaving] = useState(false)
  const [isUpdatingFromDB, setIsUpdatingFromDB] = useState(false) // New flag to prevent useEffect interference
  const [paymentStatus, setPaymentStatus] = useState('UNPAID') // Working status (dropdown)
  const [dbPaymentStatus, setDbPaymentStatus] = useState('UNPAID') // Saved DB status (display only)
  const [billingRecord, setBillingRecord] = useState(null)
  const [billingRecordError, setBillingRecordError] = useState(null)
  const [invoiceModal, setInvoiceModal] = useState({
    open: false,
    type: '', // 'success', 'error', 'info'
    title: '',
    message: '',
  })
  const chosenDate = dayjs(invoiceDate)

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  const today = new Date(invoiceDate)
  const CurrentMonth = today.getMonth()

  const dateObject = new Date(invoiceDate)
  const invoiceYear = dateObject.getFullYear()
  const invoiceMonth = dateObject.toLocaleString('en-US', { month: 'long' })

  const fetchZohoInvoicesByPlantId = async () => {
    try {
      console.log(
        'fetchZohoInvoicesByPlantId called, invoiceDetails:',
        invoiceDetails
      )

      // Only use getLastInvoiceNumber if invoice is not stored
      if (!invoiceDetails || invoiceDetails.length === 0) {
        console.log('Calling getLastInvoiceNumber...')
        const response = await getLastInvoiceNumber(
          state?.data?.organizationId,
          dateObject
        )

        const finalInvoiceNumber = response.invoiceNumber
        console.log(
          'Generated invoice number from getLastInvoiceNumber:',
          finalInvoiceNumber
        )
        setzohoinvoicenumber(finalInvoiceNumber)
      }
      // If invoice is stored, don't override the invoice number
      // The stored invoice number is already set by fetchInvoicesByPlantId
    } catch (error) {
      console.error('Error fetching invoice:', error.message)
    }
  }

  // Fetch billing record for the selected month
  const fetchBillingRecordForMonth = async (plantId, invoiceDate) => {
    try {
      setBillingRecordError(null)

      const result = await fetchBillingRecordByPlantAndMonth(plantId, invoiceDate)

      if (result.success && result.data) {
        setBillingRecord(result.data)

        // Populate actualGeneration
        if (result.data.actualGeneration !== undefined) {
          const formattedGeneration = result.data.actualGeneration === 0 
            ? '0' 
            : result.data.actualGeneration % 1 === 0 
              ? result.data.actualGeneration.toString() 
              : parseFloat(result.data.actualGeneration).toFixed(2)
          setEnergyValu(formattedGeneration)
          setMainEnergy(formattedGeneration)
        }

        // Populate deemedGeneration
        if (result.data.deemedGeneration !== undefined) {
          setDeemedEnergy(result.data.deemedGeneration)
        }

        // Populate tariff
        if (result.data.tariff !== undefined) {
          setMainTariff(result.data.tariff)
        }

        // Populate invoice number
        if (result.data.invoiceNumber) {
          setzohoinvoicenumber(result.data.invoiceNumber)
        }

        // Populate payment status
        if (result.data.paymentStatus) {
          setPaymentStatus(result.data.paymentStatus)
          setDbPaymentStatus(result.data.paymentStatus)
        }

        // Populate invoice date
        if (result.data.invoiceDate) {
          setFirstDate(dayjs(result.data.invoiceDate).format('YYYY-MM-DD'))
        }

        // Populate due date
        if (result.data.dueDate) {
          setDueDate(dayjs(result.data.dueDate).format('YYYY-MM-DD'))
        }

        // Show modal notification when billing record is found
        const monthYear = dayjs(invoiceDate).format('MMMM YYYY')
        setInvoiceModal({
          open: true,
          type: 'success',
          title: 'Billing Record Loaded',
          message: `Billing record loaded for ${monthYear}.`,
        })

        console.log('✅ Billing record found and loaded:', result.data)
        return result.data
      } else {
        setBillingRecord(null)
        console.warn("[WARNING] No billing record found for this month")
        return null
      }
    } catch (error) {
      console.error('Error fetching billing record:', error)
      return null
    }
  }

  // Sync payment status to billing record
  const syncPaymentStatusToBillingRecord = async (newStatus) => {
    if (!billingRecord) {
      console.warn('No billing record to update')
      return
    }

    try {
      await updateBillingRecordWithInvoice(billingRecord.id, {
        paymentStatus: newStatus,
      })
      console.log(`✅ Billing record payment status updated to: ${newStatus}`)
    } catch (error) {
      console.error('Error syncing payment status to billing record:', error)
    }
  }

  const handleAutoReminderClick = (newStatus) => {
    // Check if invoice exists before allowing auto reminder changes
    if (!invoiceDetails || invoiceDetails.length === 0) {
      setEmailStatus({
        open: true,
        message: 'Please create invoice first',
        severity: 'warning',
      })
      return
    }

    setPendingAutoReminderStatus(newStatus)
    setAutoReminderDialogOpen(true)
  }

  const handleConfirmAutoReminder = () => {
    updateAutomationStatus(pendingAutoReminderStatus)
    setAutoReminderDialogOpen(false)
  }

  const updateAutomationStatus = async (automationStatus) => {
    try {
      const invoice_id = invoiceDetails?.[0]?._id
      if (!invoice_id) {
        console.error('No invoice ID found')
        return
      }

      const updatedFields = {
        autoGenerate: Boolean(automationStatus),
        automated: Boolean(automationStatus),
        updatedAt: new Date().toISOString(),
      }

      console.log('Sending automation update:', updatedFields)

      const url = `${expressURL}/api/invoices/${invoice_id}`
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          accept: '*/*',
        },
        body: JSON.stringify(updatedFields),
      })

      if (response.ok) {
        const responseData = await response.json()
        console.log('Automation status updated successfully:', responseData)

        // Set flag to prevent useEffect interference
        setIsUpdatingFromDB(true)

        // Update local state
        setAutoGenerate(Boolean(automationStatus))
        setAutomated(Boolean(automationStatus))
        setUpdatedAt(new Date().toISOString())

        // Refresh invoice data from database to ensure consistency
        await fetchInvoicesByPlantId(true, false)

        // Reset flag after a brief delay
        setTimeout(() => {
          setIsUpdatingFromDB(false)
        }, 100)
      } else {
        const errorData = await response.json()
        console.error('Error updating automation status:', errorData)
      }
    } catch (error) {
      console.error('Update automation status error:', error)
    }
  }

  const fetchInvoicesByPlantId = async (
    preserveCurrentDate = false,
    preventStateUpdate = false
  ) => {
    console.log('Invoice Fetching invoices for plantId:', state?.data?.plantId)
    console.log('Invoice Date:', invoiceDate)
    console.log('data:', state?.data)

    const baseURL = `${expressURL}/api/invoices/plant`
    const url = `${baseURL}/${state.data.plantId}?invoiceDate=${invoiceDate}&plantname=${state?.data?.plantName}`

    console.log('🔍 Fetching invoice with URL:', url)

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: '*/*',
        },
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch invoices. Status: ${response.status}`)
      }

      const invoiceData = await response.json()
      console.log('📦 Invoice API response:', invoiceData)
      console.log('📄 Invoice data array:', invoiceData.data)
      console.log('📊 Number of invoices found:', invoiceData.data?.length || 0)

      // Only update invoice details if not preventing state updates
      if (!preventStateUpdate) {
        // Update invoice details state
        setInvoiceDetails(invoiceData.data)

        // Update the invoice number from the stored data in MongoDB
        const storedInvoiceNumber = invoiceData.data?.[0]?.invoiceNumber
        if (storedInvoiceNumber) {
          setzohoinvoicenumber(storedInvoiceNumber)
        }

        // Update paymentStatus from the stored data
        const storedPaymentStatus = invoiceData.data?.[0]?.paymentStatus
        if (storedPaymentStatus !== undefined) {
          // Normalize to uppercase for consistency
          const normalizedStatus = storedPaymentStatus.toUpperCase()
          setPaymentStatus(normalizedStatus) // Set working status
          setDbPaymentStatus(normalizedStatus) // Set DB status for display
        }

        // Update automation fields from the stored data
        const storedAutoGenerate = invoiceData.data?.[0]?.autoGenerate
        const storedAutomated = invoiceData.data?.[0]?.automated
        const storedCreatedAt = invoiceData.data?.[0]?.createdAt
        const storedUpdatedAt = invoiceData.data?.[0]?.updatedAt

        // If either field exists, use it to set both states (for backward compatibility)
        const automationValue =
          storedAutoGenerate !== undefined
            ? Boolean(storedAutoGenerate)
            : storedAutomated !== undefined
            ? Boolean(storedAutomated)
            : false

        console.log(
          'Fetched automation values - autoGenerate:',
          storedAutoGenerate,
          'automated:',
          storedAutomated,
          'Final value:',
          automationValue
        )

        setAutoGenerate(automationValue)
        setAutomated(automationValue)
        if (storedCreatedAt) {
          setCreatedAt(storedCreatedAt)
        }
        if (storedUpdatedAt) {
          setUpdatedAt(storedUpdatedAt)
        }

        // Only update the date if we're not preserving the current date AND there's no current date set
        if (
          !preserveCurrentDate &&
          (!firstDate || firstDate === new Date().toISOString().split('T')[0])
        ) {
          // Use invoiceDate from DB instead of sentDate
          const inv = invoiceData.data?.[0]?.invoiceDate
          if (inv) {
            setFirstDate(dayjs(inv).format('YYYY-MM-DD'))
          }
        }

        // Populate dueDate from DB if available
        const storedDueDate = invoiceData.data?.[0]?.dueDate
        if (storedDueDate) {
          setDueDate(dayjs(storedDueDate).format('YYYY-MM-DD'))
        } else {
          // Compute default due date using paymentTermsDays
          const terms = Number(state?.data?.paymentTermsDays) || 7
          const baseDate = invoiceData.data?.[0]?.invoiceDate || invoiceDate
          setDueDate(dayjs(baseDate).add(terms, 'day').format('YYYY-MM-DD'))
        }

        // Update Zoho connection status
        setZohoConnected(invoiceData.data?.[0]?.sentToZoho || false)
      }

      return invoiceData
    } catch (error) {
      console.error('Error fetching invoice:', error.message)
      throw error
    }
  }

  // Fetch invoice data when the component is mounted
  useEffect(() => {
    const initializeData = async () => {
      // First, fetch the invoice data to check if it exists
      const invoiceData = await fetchInvoicesByPlantId()
      console.log('Invoice data fetched:', invoiceData?.data)

      // Always fetch billing record to check if it exists (needed for validation)
      let billingRecordData = null
      if (state?.data?.plantId) {
        billingRecordData = await fetchBillingRecordForMonth(state.data.plantId, invoiceDate)
      }

      // Decide what to display based on invoice existence
      const invoiceExists = invoiceData?.data && invoiceData.data.length > 0

      if (invoiceExists) {
        // CASE 1: Invoice exists → Display invoice data (invoice is source of truth)
        console.log('✅ Invoice exists - displaying invoice data')
        // Invoice data is already set by fetchInvoicesByPlantId
      } else {
        // CASE 2: No invoice exists → Pre-fill from billing record if available
        console.log('⚠️ No invoice exists')
        
        if (billingRecordData) {
          console.log('✅ Pre-filling from billing record data')
          
          // Pre-populate fields from billing record
          if (billingRecordData.actualGeneration !== undefined) {
            const formattedGeneration = billingRecordData.actualGeneration === 0 
              ? '0' 
              : billingRecordData.actualGeneration % 1 === 0 
                ? billingRecordData.actualGeneration.toString() 
                : parseFloat(billingRecordData.actualGeneration).toFixed(2)
            setEnergyValu(formattedGeneration)
            setMainEnergy(formattedGeneration)
          }

          if (billingRecordData.deemedGeneration !== undefined) {
            setDeemedEnergy(billingRecordData.deemedGeneration)
          }

          if (billingRecordData.tariff !== undefined) {
            setMainTariff(billingRecordData.tariff)
          }

          if (billingRecordData.invoiceNumber) {
            setzohoinvoicenumber(billingRecordData.invoiceNumber)
          } else {
            // No invoice number in billing record - generate one
            console.log('🔢 Generating invoice number...')
            await fetchZohoInvoicesByPlantId()
          }

          // For invoices, always default to 'UNPAID' status (not 'Draft' from billing record)
          setPaymentStatus('UNPAID')
          setDbPaymentStatus('UNPAID')
          console.log('💳 Status set to UNPAID for new invoice')

          if (billingRecordData.invoiceDate) {
            // Use invoiceDate from billing record, but ensure it's in the correct month
            const billingRecordInvoiceDate = dayjs(billingRecordData.invoiceDate)
            const selectedMonth = dayjs(invoiceDate)
            
            // Check if billing record's invoiceDate matches the selected month
            if (billingRecordInvoiceDate.month() === selectedMonth.month() && 
                billingRecordInvoiceDate.year() === selectedMonth.year()) {
              setFirstDate(billingRecordInvoiceDate.format('YYYY-MM-DD'))
            } else {
              // Month mismatch - use last day of selected month
              console.log('⚠️ Billing record invoiceDate month mismatch. Using last day of selected month.')
              setFirstDate(selectedMonth.endOf('month').format('YYYY-MM-DD'))
            }
          } else {
            // No invoiceDate in billing record - use last day of selected month
            setFirstDate(dayjs(invoiceDate).endOf('month').format('YYYY-MM-DD'))
          }

          if (billingRecordData.dueDate) {
            setDueDate(dayjs(billingRecordData.dueDate).format('YYYY-MM-DD'))
          }
        } else {
          // No billing record and no invoice - fetch next invoice number and set UNPAID
          console.log('⚠️ No billing record found, fetching next invoice number')
          await fetchZohoInvoicesByPlantId()
          setPaymentStatus('UNPAID')
          setDbPaymentStatus('UNPAID')
        }
      }
    }
    initializeData()
  }, [invoiceDate]) // ✅ Re-run when invoice date changes

  // Reset firstDate when billing month changes (only if no invoice exists yet)
  useEffect(() => {
    if (!invoiceDetails || invoiceDetails.length === 0) {
      const newDefaultDate = getDefaultInvoiceDate()
      console.log('📅 Billing month changed, resetting invoice date to:', newDefaultDate)
      setFirstDate(newDefaultDate)
    }
  }, [invoiceDate])

  // Don't call fetchZohoInvoicesByPlantId on invoiceDetails changes
  // since fetchInvoicesByPlantId already handles setting the stored invoice number

  const deemedTariffValue =
    invoiceDetails?.find((item) => item.deemedTariff)?.deemedTariff ?? 0
  const deemedEnergyValue =
    invoiceDetails?.find((item) => item.deemedEnergy)?.deemedEnergy ?? 0
  const mainTariffValue =
    invoiceDetails?.find((item) => item.mainTariff)?.mainTariff ?? 0

  console.log(
    'deemedTariffValue',
    deemedTariffValue,
    deemedEnergyValue,
    mainTariffValue
  )

  const [deemedEnergy, setDeemedEnergy] = useState(deemedEnergyValue)
  const [mainTariff, setMainTariff] = useState(mainTariffValue)
  const [deemedTariff, setDeemedTariff] = useState(deemedTariffValue)

  // Fix 1: Update the useEffect that handles invoiceDetails changes
  useEffect(() => {
    if (
      invoiceDetails &&
      invoiceDetails.length > 0 &&
      !isSaving &&
      !isUpdatingFromDB
    ) {
      const storedDeemedEnergy = invoiceDetails.find(
        (item) => item.deemedEnergy !== undefined
      )?.deemedEnergy
      const storedDeemedTariff = invoiceDetails.find(
        (item) => item.deemedTariff !== undefined
      )?.deemedTariff
      const storedMainTariff = invoiceDetails.find(
        (item) => item.mainTariff !== undefined
      )?.mainTariff
      const storedEnergyValue = invoiceDetails.find(
        (item) => item.energyValue !== undefined
      )?.energyValue
      const storedPaymentStatus = invoiceDetails.find(
        (item) => item.paymentStatus !== undefined
      )?.paymentStatus
      const storedInvoiceDate = invoiceDetails.find(
        (item) => item.invoiceDate !== undefined
      )?.invoiceDate
      const storedDueDate = invoiceDetails.find(
        (item) => item.dueDate !== undefined
      )?.dueDate
      const storedAutoGenerate = invoiceDetails.find(
        (item) => item.autoGenerate !== undefined
      )?.autoGenerate
      const storedAutomated = invoiceDetails.find(
        (item) => item.automated !== undefined
      )?.automated
      const storedCreatedAt = invoiceDetails.find(
        (item) => item.createdAt !== undefined
      )?.createdAt
      const storedUpdatedAt = invoiceDetails.find(
        (item) => item.updatedAt !== undefined
      )?.updatedAt

      console.log(
        'useEffect: Loading from DB - autoGenerate:',
        storedAutoGenerate,
        'automated:',
        storedAutomated,
        'Types:',
        typeof storedAutoGenerate,
        typeof storedAutomated
      )

      // Update values if they exist in the database (including zero values)
      if (storedDeemedEnergy !== undefined) {
        setDeemedEnergy(storedDeemedEnergy)
      }
      if (storedDeemedTariff !== undefined) {
        setDeemedTariff(storedDeemedTariff)
      }
      if (storedMainTariff !== undefined) {
        setMainTariff(storedMainTariff)
      }
      if (storedEnergyValue !== undefined) {
        setEnergyValu(storedEnergyValue)
        setMainEnergy(storedEnergyValue)
      }
      if (storedPaymentStatus !== undefined) {
        setPaymentStatus(storedPaymentStatus) // Set working status
        setDbPaymentStatus(storedPaymentStatus) // Set DB status for display
      }
      if (storedInvoiceDate) {
        setFirstDate(storedInvoiceDate)
      }
      if (storedDueDate) {
        setDueDate(storedDueDate)
      } else {
        const terms = Number(state?.data?.paymentTermsDays) || 7
        setDueDate(
          dayjs(firstDate || invoiceDate)
            .add(terms, 'day')
            .format('YYYY-MM-DD')
        )
      }

      // Handle automation fields - use either field if present (backward compatibility)
      const automationValue =
        storedAutoGenerate !== undefined
          ? Boolean(storedAutoGenerate)
          : storedAutomated !== undefined
          ? Boolean(storedAutomated)
          : false

      console.log('useEffect: Setting automation to:', automationValue)
      setAutoGenerate(automationValue)
      setAutomated(automationValue)
      if (storedCreatedAt) {
        setCreatedAt(storedCreatedAt)
      }
      if (storedUpdatedAt) {
        setUpdatedAt(storedUpdatedAt)
      }
    }
  }, [invoiceDetails, isSaving, isUpdatingFromDB])

  const targetRef = useRef()

  const calculateTotals = () => {
    const effectiveEnergy =
      energyValu !== null && energyValu !== undefined
        ? parseFloat(energyValu)
        : parseFloat(mainEnergy || 0)

    const mainAmount = effectiveEnergy * parseFloat(mainTariff || 0)

    const deemedAmount =
      parseFloat(deemedEnergy || 0) * parseFloat(deemedTariff || 0)

    // Calculate totaltarif based on proposal type
    const totaltarif =
      parseFloat(mainTariff || 0) + parseFloat(deemedTariff || 0)
    const totalAmount = mainAmount + deemedAmount
    const totalBillableUnits = effectiveEnergy + parseFloat(deemedEnergy || 0)
    const totalFailure = Object.values(faultEvents).reduce(
      (sum, value) => sum + parseFloat(value || 0),
      0
    )

    // Calculate rounding for invoiceValue
    const subTotal =
      state?.data?.proposalType?.type === 'EMI' ? totaltarif : totalAmount
    const roundedTotal = Math.round(subTotal)
    const roundingOff = roundedTotal - subTotal

    const paymentTotals = calculatePaymentTotals()

    return {
      mainAmount,
      deemedAmount,
      totalAmount,
      totaltarif,
      totalBillableUnits,
      totalFailure,
      subTotal,
      roundedTotal,
      roundingOff,
      outstandingTotal: paymentTotals.outstandingTotal,
      pendingTotal: paymentTotals.pendingTotal,
    }
  }

  const calculatePaymentTotals = () => {
    return outstandingPayments.reduce(
      (acc, payment) => ({
        outstandingTotal:
          acc.outstandingTotal + Number(payment.invoiceAmount || 0),
        pendingTotal: acc.pendingTotal + Number(payment.pendingAmount || 0),
      }),
      { outstandingTotal: 0, pendingTotal: 0 }
    )
  }

  const energyValue =
    invoiceDetails?.find((item) => item.energyValue)?.energyValue ?? null
  const invoiceNumber =
    invoiceDetails?.find((item) => item.invoiceNumber)?.invoiceNumber ?? null
  const deemedGeneration =
    invoiceDetails?.find((item) => item.deemedGeneration)?.deemedGeneration ??
    null

  const invoice_id = invoiceDetails?.find((item) => item._id)?._id
  const [energyValu, setEnergyValu] = useState(energyValue)
  const [deemedGener, setDeemedGener] = useState(deemedGeneration)

  useEffect(() => {
    if (energyValue !== null) {
      const num = parseFloat(energyValue)
      // If it's zero or no value, set to '0', otherwise format properly
      if (num === 0) {
        setEnergyValu('0')
      } else {
        setEnergyValu(num % 1 === 0 ? num.toString() : num.toFixed(2))
      }
    }
  }, [energyValue]) // Runs whenever energyValue changes

  useEffect(() => {
    if (deemedGeneration !== null) {
      const num = parseFloat(deemedGeneration)
      // If it's zero or no value, set to '0', otherwise format properly
      if (num === 0) {
        setDeemedGener('0')
      } else {
        setDeemedGener(num % 1 === 0 ? num.toString() : num.toFixed(2))
      }
    }
  }, [deemedGeneration])

  // Create a function to generate PDF with specific values (prevents state interference)
  const generatePDFWithValues = async (specificValues) => {
    // Temporarily store current state values
    const currentValues = {
      energyValu,
      deemedEnergy,
      deemedTariff,
      mainTariff,
      firstDate,
      deemedGener, // ADD THIS LINE - Include deemedGener in preserved values
    }

    try {
      // Temporarily set the specific values for PDF generation
      if (specificValues) {
        setEnergyValu(specificValues.energyValu)
        setDeemedEnergy(specificValues.deemedEnergy)
        setDeemedTariff(specificValues.deemedTariff)
        setMainTariff(specificValues.mainTariff)
        setFirstDate(specificValues.firstDate)
        setDeemedGener(specificValues.deemedGener) // ADD THIS LINE - Set deemedGener

        // Wait a bit to ensure state is updated
        await new Promise((resolve) => setTimeout(resolve, 100))
      }

      const pdfs = await generatePDF(false, state)

      // Download each PDF with a specific filename
      pdfs.forEach((pdf, index) => {
        const filename = index === 0 ? 'Invoice.pdf' : `O&MInvoice.pdf`
        pdf.save(filename)
      })

      setPrintMode(true)

      return pdfs
    } finally {
      // Always restore the original values
      if (specificValues) {
        setTimeout(() => {
          setEnergyValu(currentValues.energyValu)
          setDeemedEnergy(currentValues.deemedEnergy)
          setDeemedTariff(currentValues.deemedTariff)
          setMainTariff(currentValues.mainTariff)
          setFirstDate(currentValues.firstDate)
          setDeemedGener(currentValues.deemedGener) // ADD THIS LINE - Restore deemedGener
        }, 100)
      }
    }
  }

  const updateInvoiceDetails = async () => {
    // Calculate mainAmount and deemedAmount using CURRENT edited values (energyValu, not old energyValue)
    const mainAmount =
      parseFloat(
        energyValu !== null && energyValu !== undefined
          ? energyValu
          : mainEnergy || 0
      ) * parseFloat(mainTariff || 0)

    const deemedAmount =
      parseFloat(deemedEnergy || 0) * parseFloat(deemedTariff || 0)

    // Calculate totalAmount using the newly calculated deemedAmount (not the old deemedGeneration)
    const totalAmount = mainAmount + deemedAmount

    const totaltarif =
      parseFloat(mainTariff || 0) +
      parseFloat(deemedTariff || 0) +
      parseFloat(omAmounts)

    const subTotal =
      state?.data?.proposalType?.type === 'EMI'
        ? totaltarif || 0
        : totalAmount || 0

    // Calculate rounding
    const roundedTotal = Math.round(subTotal)
    const roundingOff = roundedTotal - subTotal

    const matchingInvoice = outstandingPayments.find(
      (payment) => payment?.invoiceID === invoiceNumber
    )

    const status = paymentStatus || 'UNPAID'
    // Normalize numeric fields to ensure numbers are sent to backend
    const numericEnergyValue =
      energyValu !== null && energyValu !== undefined
        ? parseFloat(energyValu) || 0
        : parseFloat(mainEnergy || 0) || 0

    const numericDeemedEnergy = parseFloat(deemedEnergy) || 0
    const numericDeemedTariff = parseFloat(deemedTariff) || 0
    const numericMainTariff = parseFloat(mainTariff) || 0
    // Use the newly calculated deemedAmount as deemedGeneration
    const numericDeemedGeneration = deemedAmount

    // Create the updated invoice object
    const updatedInvoice = {
      invoiceNumber: zohoinvoicenumber,
      plantId: state.data.plantId,
      plantName: state.data.plantName,
      energyValue: numericEnergyValue,
      invoiceValue: roundedTotal, // Use rounded total
      roundingOff: roundingOff, // Add rounding off field
      type: state?.data.proposalType.type,
      deemedGeneration: numericDeemedGeneration,
      deemedTariff: numericDeemedTariff,
      deemedEnergy: numericDeemedEnergy,
      mainTariff: numericMainTariff,
      remarks: `Manual-generated invoice for ${moment(
        new Date().toISOString()
      ).format('MMMM YYYY')}`,
      // Use invoiceDate instead of sentDate
      invoiceDate: dayjs(firstDate || new Date()).format('YYYY-MM-DD'),
      // Include dueDate in updates
      dueDate: dayjs(
        dueDate ||
          dayjs(firstDate).add(
            Number(state?.data?.paymentTermsDays) || 7,
            'day'
          )
      ).format('YYYY-MM-DD'),
      paymentStatus: status.toUpperCase(),
      zohoinvoicenumber: zohoinvoicenumber,
      autoGenerate: autoGenerate,
      automated: automated,
      updatedAt: new Date().toISOString(),
    }

    // const url = `https://prod.backend.v2.express.de.energy/api/invoices/${invoice_id}`
    const url = `${expressURL}/api/invoices/${invoice_id}`

    try {
      // Send the PUT request to update the invoice
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          accept: '*/*',
        },
        body: JSON.stringify(updatedInvoice),
      })
      if (response.ok) {
        setDateLoed(true)
        setUpdatedAt(new Date().toISOString()) // Update the updatedAt timestamp
        
        //Sync ALL changes to billing record (including dates, status, and invoice number)
        await syncBillingRecordFromInvoice(
          state.data.plantId,
          firstDate || invoiceDate,
          {
            energyValue: numericEnergyValue,
            deemedEnergy: numericDeemedEnergy,
            mainTariff: numericMainTariff,
            invoiceValue: roundedTotal,
            paymentStatus: status.toUpperCase(),
            invoiceNumber: zohoinvoicenumber,
            invoiceDate: dayjs(firstDate || new Date()).format('YYYY-MM-DD'),
            dueDate: dayjs(
              dueDate ||
                dayjs(firstDate).add(
                  Number(state?.data?.paymentTermsDays) || 7,
                  'day'
                )
            ).format('YYYY-MM-DD'),
          }
        )
      } else {
        console.error('Error updating invoice:', response.statusText)
      }
    } catch (error) {
      console.error('Update Error:', error)
    }
  }

  const createInvoiceDetails = async () => {
    setIsDownloading(true)

    //Check if billing record exists before creating invoice
    if (!billingRecord) {
      setSaveStatus({
        open: true,
        message: billingRecordError || 'No billing record found. Please contact Asset Management.',
        severity: 'error',
      })
      setIsDownloading(false)
      return
    }

    const randomPart = Math.floor(Math.random() * 9000) + 1000 // Generates a 4-digit random number

    const invoicenumber = `INV-${state?.data?.plantName
      ?.split(' ')
      .pop()
      .substring(0, 3)
      .toUpperCase()}-${dayjs(invoiceDate).format('YYYYMM')}`

    // Use edited invoice date (firstDate) instead of the prop invoiceDate
    let individualInvoicedate = `${dayjs(firstDate || invoiceDate).format(
      'YYYY-MM-DD'
    )}`

    const totalBillableUnits = parseFloat(mainEnergy)
    const mainAmount =
      parseFloat(
        energyValu !== null && energyValu !== undefined
          ? energyValu
          : mainEnergy || 0
      ) * parseFloat(mainTariff || 0)
    const deemedAmount =
      parseFloat(deemedEnergy || 0) * parseFloat(deemedTariff || 0)
    // Use the newly calculated deemedAmount, not the old deemedGeneration
    const totalAmount = mainAmount + deemedAmount
    const type = state?.data.proposalType.type

    const totaltarif =
      parseFloat(mainTariff || 0) +
      parseFloat(deemedTariff || 0) +
      parseFloat(omAmounts)

    const subTotal =
      state?.data?.proposalType?.type === 'EMI'
        ? totaltarif || 0
        : totalAmount || 0

    // Calculate rounding
    const roundedTotal = Math.round(subTotal)
    const roundingOff = roundedTotal - subTotal

    const matchingInvoice = outstandingPayments.find(
      (payment) => payment?.invoiceID === invoicenumber
    )
    const status = matchingInvoice?.status || 'UNPAID'

    // Normalize numeric fields to ensure numbers are sent to backend
    const numericTotalBillableUnits = parseFloat(totalBillableUnits) || 0
    const numericDeemedTariff = parseFloat(deemedTariff) || 0
    const numericDeemedEnergy = parseFloat(deemedEnergy) || 0
    const numericMainTariff = parseFloat(mainTariff) || 0

    const newInvoice = {
      invoiceNumber: zohoinvoicenumber,
      plantId: state.data.plantId,
      plantName: state.data.plantName,
      invoiceValue: roundedTotal, // Use rounded total
      roundingOff: roundingOff, // Add rounding off field
      energyValue: numericTotalBillableUnits,
      deemedTariff: numericDeemedTariff,
      deemedEnergy: numericDeemedEnergy,
      mainTariff: numericMainTariff,
      type: type,
      deemedGeneration: deemedAmount,
      paymentStatus: status.toUpperCase(),
      remarks: `Manul-generated invoice for ${moment(
        new Date().toISOString()
      ).format('MMMM YYYY')}`,
      // Always send invoiceDate (replaces previous sentDate usage)
      invoiceDate: individualInvoicedate,
      // Include dueDate in creation
      dueDate: dayjs(
        dueDate ||
          dayjs(individualInvoicedate).add(
            Number(state?.data?.paymentTermsDays) || 7,
            'day'
          )
      ).format('YYYY-MM-DD'),
      zohoUpdates: zohoState,
      zohoinvoicenumber: zohoinvoicenumber,
      organizationId: state.data.organizationId,
      autoGenerate: autoGenerate,
      automated: automated,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }

    // const url = 'https://prod.backend.v2.express.de.energy/api/invoices' // POST endpoint
    // const url = `https://prod.backend.v2.express.de.energy/api/invoices/${invoice_id}`
    const url = `${expressURL}/api/invoices`
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          accept: '*/*',
        },
        body: JSON.stringify(newInvoice),
      })

      if (response.ok) {
        const createdInvoice = await response.json()
        setCreatedAt(new Date().toISOString()) // Set the createdAt timestamp
        setUpdatedAt(new Date().toISOString()) // Set the updatedAt timestamp

        //Sync ALL invoice details to billing record
        await syncBillingRecordFromInvoice(
          state.data.plantId,
          individualInvoicedate,
          {
            energyValue: numericTotalBillableUnits,
            deemedEnergy: numericDeemedEnergy,
            mainTariff: numericMainTariff,
            invoiceValue: roundedTotal,
            paymentStatus: status.toUpperCase(),
            invoiceNumber: zohoinvoicenumber,
            invoiceDate: individualInvoicedate,
            dueDate: dayjs(
              dueDate ||
                dayjs(individualInvoicedate).add(
                  Number(state?.data?.paymentTermsDays) || 7,
                  'day'
                )
            ).format('YYYY-MM-DD'),
          }
        )
        console.log('✅ Billing record synced with new invoice details')
        
        return createdInvoice
      } else {
        console.error('Error creating invoice:', response.statusText)
      }
      setIsDownloading(false)
    } catch (error) {
      console.error('Create Error:', error)
    }
  }

  const FetchCurrency = (currency) => {
    if (currency === 'INR') return '₹'
    else if (currency === 'USD') return '$'
    return currency
  }

  const handlePrint = async () => {
    setIsDownloading(true)
    try {
      const pdfs = await generatePDF(false, state) // Get array of PDFs

      // Download each PDF with a specific filename
      pdfs.forEach((pdf, index) => {
        const filename = index === 0 ? 'Invoice.pdf' : `O&MInvoice.pdf`
        pdf.save(filename)
      })

      setPrintMode(true)
    } catch (error) {
      setEmailStatus({
        open: true,
        message: 'Error generating PDF',
        severity: 'error',
      })
    }
    setIsDownloading(false)
  }

  const sendEmail = async (recipientEmails, ccEmails, recipientType) => {
    // setIsDownloading(true)
    const buttonType = recipientType === 'team' ? 'emailTeam' : 'emailCustomer'
    setProcessingButton(buttonType)
    try {
      // Ensure recipientEmails is an array and filter out empty values
      const emailList = Array.isArray(recipientEmails)
        ? recipientEmails.filter((email) => email)
        : [recipientEmails].filter((email) => email)

      // Ensure ccEmails is an array and filter out empty values
      const ccList = Array.isArray(ccEmails)
        ? ccEmails.filter((email) => email)
        : ccEmails
        ? [ccEmails].filter((email) => email)
        : []

      // Validate email list
      if (emailList.length === 0) {
        throw new Error('No recipient emails found')
      }

      // Get PDFs
      const pdfs = await generatePDF(true, state)

      // Prepare attachments (assuming first PDF is the main invoice)
      const attachments = pdfs.map((pdf, index) => {
        // Convert PDF to base64
        const pdfBase64 = pdf.output('datauristring')
        const base64Data = pdfBase64.split(',')[1]

        // Name the attachments
        const filename =
          index === 0
            ? 'Invoice.pdf'
            : pdfs.length > 1
            ? 'O&MInvoice.pdf'
            : 'Additional-Invoice.pdf'

        return {
          content: base64Data,
          name: filename,
          type: 'application/pdf',
        }
      })

      const emailContent = emailTemplate(
        state,
        firstDate,
        totals,
        zohoinvoicenumber,
        zohoState
      )

      // Build the email payload with all recipients and cc
      const senderDisplayName =
        zohoState?.organizationName ||
        state?.data?.entity?.billerDetails?.entityName ||
        DEFAULT_SENDER_NAME

      const compressedEmailData = {
        sender: { name: senderDisplayName, email: SENDER_EMAIL },
        to: emailList.slice(0, 5).map((email) => ({ email: email.trim() })),
        subject: `Invoice- ${state?.data?.plantName} - ${dayjs(
          invoiceDate
        ).format('MMMM YYYY')}`,
        htmlContent: emailContent,
        attachment: attachments, // Use the prepared attachments
      }

      // Add CC only when there are valid CC addresses (Brevo expects cc omitted otherwise)
      if (ccList && ccList.length > 0) {
        compressedEmailData.cc = ccList
          .filter((ccEmail) => ccEmail)
          .map((ccEmail) => ({ email: ccEmail.trim() }))
      }

      // Send email once and capture response
      let emailResponse = null
      try {
        emailResponse = await axios.post(
          'https://api.brevo.com/v3/smtp/email',
          compressedEmailData,
          {
            headers: {
              accept: 'application/json',
              'api-key': BREVO_API_KEY,
              'content-type': 'application/json',
            },
            timeout: 10000, // 10 second timeout
          }
        )
      } catch (emailError) {
        console.error('Error sending email:', emailError)
        emailResponse = null
      }

      // Check if email was sent successfully
      const successfulEmails =
        emailResponse && (emailResponse.status === 201 || emailResponse.status === 200)
          ? [emailResponse]
          : []

      if (successfulEmails.length > 0) {
        setEmailStatus({
          open: true,
          message: `Email sent successfully to ${recipientType}`,
          severity: 'success',
        })

        // If customer email, update invoice with email status
        if (recipientType === 'customer') {
          try {
            const invoice_id = invoiceDetails?.[0]?._id
            if (invoice_id) {
              const currentDate = dayjs().format('YYYY-MM-DD')

              // Update invoice with emailSent: true and sentDate
              await updateInvoiceEmailStatus(invoice_id, true, currentDate)

              console.log('Invoice email status updated successfully')

              // Immediately update local state to reflect the change in UI
              setInvoiceDetails((prevDetails) => {
                if (prevDetails && prevDetails.length > 0) {
                  const updatedDetails = [...prevDetails]
                  updatedDetails[0] = {
                    ...updatedDetails[0],
                    emailSent: true,
                    sentDate: currentDate,
                  }
                  return updatedDetails
                }
                return prevDetails
              })
            }
          } catch (e) {
            console.error('Failed to update invoice email status:', e)
          }
        }
      } else {
        throw new Error('Failed to send emails')
      }
    } catch (error) {
      console.error('Email sending error:', error)
      setEmailStatus({
        open: true,
        message: `Failed to send email to ${recipientType}: ${error.message}`,
        severity: 'error',
      })
      // Update invoice with failure status for customer email
      if (recipientType === 'customer') {
        try {
          const invoice_id = invoiceDetails?.[0]?._id
          if (invoice_id) {
            const currentDate = dayjs().format('YYYY-MM-DD')

            // Update invoice with emailSent: false and sentDate
            await updateInvoiceEmailStatus(invoice_id, false, currentDate)

            // Immediately update local state to reflect the failure in UI
            setInvoiceDetails((prevDetails) => {
              if (prevDetails && prevDetails.length > 0) {
                const updatedDetails = [...prevDetails]
                updatedDetails[0] = {
                  ...updatedDetails[0],
                  emailSent: false,
                  sentDate: currentDate,
                }
                return updatedDetails
              }
              return prevDetails
            })
          }
        } catch (e) {
          console.error('Failed to update invoice email status (failure):', e)
        }
      }
    } finally {
      // setIsDownloading(false)
      setProcessingButton(null) // Reset processing state

      setConfirmDialogOpen(false)
    }
  }

  // Handle confirm email with dynamic recipient loading
  const handleConfirmEmail = async () => {
    try {
      // Access emailDialogData which now contains our loaded emails
      const { toEmails, ccEmails } = emailDialogData

      if (!toEmails || toEmails.length === 0) {
        throw new Error('No recipient emails available')
      }

      await sendEmail(toEmails, ccEmails, emailType)
    } catch (error) {
      console.error('Email confirmation error:', error)
      setEmailStatus({
        open: true,
        message: `Error sending email: ${error.message}`,
        severity: 'error',
      })
    }
  }

  const handleEditClick = () => {
    setSnackbarOpen(true)
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return
    setSnackbarOpen(false)
  }

  const handleFaultEventChange = (event, key) => {
    const value = parseFloat(event.target.value || 0)
    setFaultEvents((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const handleAccountableFailureChange = (event) => {
    const value = parseFloat(event.target.value || 0)
    setAccountableFailure(value)
  }

  const handleEditPayment = (id) => {
    setEditingPaymentId(id)
  }

  const handleSavePayment = (invoiceID, invoice_id) => {
    const matchingInvoice = outstandingPayments.find(
      (payment) => payment.invoiceID === invoiceID
    )
    const paymentStatus = matchingInvoice?.status

    updateMultipleFields({ invoiceID, invoice_id, paymentStatus })

    setEditingPaymentId(null)
  }

  const handleCancelPayment = (id) => {
    setEditingPaymentId(null)
  }

  const handlePaymentChange = (id, field, value) => {
    setOutstandingPayments((prevPayments) => {
      return prevPayments.map((payment) => {
        if (payment.id === id) {
          const updatedPayment = { ...payment, [field]: value }
          if (field === 'status') {
            updatedPayment.pendingAmount =
              value === 'PAID' ? 0 : updatedPayment.invoiceAmount
          }
          if (field === 'invoiceAmount') {
            updatedPayment.pendingAmount =
              payment.status === 'PAID' ? 0 : Number(value)
          }
          return updatedPayment
        }
        return payment
      })
    })
  }

  useEffect(() => {
    if (energyValue !== null) {
      setEnergyValu(parseFloat(energyValue).toFixed(2))
      const newTotals = calculateTotals()
    }
  }, [energyValue, firstDate, setDeemedEnergy, setDeemedTariff])

  useEffect(() => {
    if (deemedGeneration !== null) {
      setDeemedGener(parseFloat(deemedGeneration).toFixed(2))
      const newTotals = calculateTotals()
    }
  }, [deemedGeneration])

  const handleAddPayment = () => {
    const newId = `payment-${outstandingPayments.length}`
    const newPayment = {
      id: newId,
      date: dayjs().format('YYYY-MM'),
      transactionNo: `INV-${dayjs().format('YYYY/MM')}-${String(
        outstandingPayments.length + 1
      ).padStart(3, '0')}`,
      type: 'INVOICE',
      status: 'UNPAID',
      invoiceAmount: 0,
      pendingAmount: 0,
    }
    setOutstandingPayments([...outstandingPayments, newPayment])
    setEditingPaymentId(newId)
  }

  const handleDeletePayment = (id) => {
    setOutstandingPayments((prevPayments) =>
      prevPayments.filter((payment) => payment.id !== id)
    )
  }

  useEffect(() => {
    const style = document.createElement('style')
    style.innerHTML = `
      @media print {
        .print-no-border {
          border: none !important;
        }
        .print-no-border td, .print-no-border th {
          border: none !important;
        }
        .no-print {
          display: none !important;
           border: none !important;
        }
        input {
          border: none !important;
          background: transparent !important;
        }
        /* Hide MUI TextField borders in PDF */
        .MuiInput-root:before,
        .MuiInput-root:after {
          border-bottom: none !important;
        }
        .MuiInputBase-root {
          border: none !important;
        }
        .MuiInputBase-input {
          border: none !important;
          -webkit-appearance: none !important;
        }
        /* Hide all TextField underlines */
        .MuiInput-underline:before,
        .MuiInput-underline:after,
        .MuiInput-underline:hover:not(.Mui-disabled):before {
          border-bottom: none !important;
        }
      }
    `
    document.head.appendChild(style)
    return () => {
      document.head.removeChild(style)
    }
  }, [])

  useEffect(() => {
    if (invoiceReportList && state) {
      const totalEnergyGenerated = parseFloat(
        invoiceReportList.totalEnergyGenerated || 0
      )
      const logTotal = parseFloat(invoiceReportList.logTotal || 0)
      const totalMultiplyingFactor = invoiceReportList.totalMultiplyingFactor

      const tariff =
        state?.data?.proposalType?.type !== 'EMI'
          ? parseFloat(state?.data?.proposalType?.tariff || 0)
          : parseFloat(state?.data?.proposalType?.monthlyEmiAmount || 0)

      const omAmount = parseFloat(
        state.data?.proposalType?.monthlyOMAmount || 0
      )

      // Get fault values and their corresponding multiplying factors
      const faultData = invoiceReportList.logTotalFault || {}
      const faultMultipliers =
        invoiceReportList.logTotalFaultMultiplyingFactor || {}

      const initialFaults = {
        GridFailure: parseFloat(faultData.GridFailure || 0),
        InverterFailure: parseFloat(faultData.InverterFailure || 0),
        Manuallyinverterbreakerturnedoff: parseFloat(
          faultData.Manuallyinverterbreakerturnedoff || 0
        ),
        VoltageFluctuations: parseFloat(faultData.VoltageFluctuations || 0),
        RelayFailureMCCBFailure: parseFloat(
          faultData.RelayFailureMCCBFailure || 0
        ),
        AnyOtherFault: parseFloat(faultData.AnyOtherFault || 0),
        CableTerminationIssue: parseFloat(faultData.CableTerminationIssue || 0),
        AnyEquipmentFailure: parseFloat(faultData.AnyEquipmentFailure || 0),
      }

      setFaultEvents(initialFaults)

      // Calculate total fault with multiplying factors
      const totalFault = Object.keys(initialFaults).reduce((sum, faultType) => {
        const faultValue = parseFloat(initialFaults[faultType]) || 0
        const multiplier = parseFloat(faultMultipliers[faultType]) || 1
        const calculatedFault = faultValue * multiplier
        return sum + calculatedFault
      }, 0)

      setAccountableFailure(totalFault)
      setOmAmounts(omAmount)

      // Only set calculated values if no invoice data exists in database
      if (!invoiceDetails || invoiceDetails.length === 0) {
        // Format energy values - show '0' for zero, no decimals for whole numbers, 2 decimals otherwise
        const formattedEnergy =
          totalEnergyGenerated === 0
            ? '0'
            : totalEnergyGenerated % 1 === 0
            ? totalEnergyGenerated.toString()
            : parseFloat(totalEnergyGenerated).toFixed(2)

        setMainEnergy(formattedEnergy)
        setDeemedEnergy(totalFault)
        setMainTariff(tariff)
        setEnergyValu(formattedEnergy)
      }

      setIsLoading(false)
    }
  }, [invoiceReportList, state, invoiceDetails]) // Added invoiceDetails as dependency

  useEffect(() => {
    const style = document.createElement('style')
    style.innerHTML = `
      @media print {
        .print-no-border {
          border: none !important;
        }
        .print-no-border td, .print-no-border th {
          border: none !important;
        }
        input {
          border: none !important;
          background: transparent !important;
        }
        /* Hide MUI TextField borders in PDF */
        .MuiInput-root:before,
        .MuiInput-root:after {
          border-bottom: none !important;
        }
        .MuiInputBase-root {
          border: none !important;
        }
        .MuiInputBase-input {
          border: none !important;
          -webkit-appearance: none !important;
        }
        /* Hide all TextField underlines */
        .MuiInput-underline:before,
        .MuiInput-underline:after,
        .MuiInput-underline:hover:not(.Mui-disabled):before {
          border-bottom: none !important;
        }
      }
    `
    document.head.appendChild(style)
    return () => {
      document.head.removeChild(style)
    }
  }, [])

  useEffect(() => {
    const allInvoice = async () => {
      // const url = 'https://prod.backend.v2.express.de.energy/api/invoices/'
      const url = `${expressURL}/api/invoices/`

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Accept: '*/*',
          },
        })

        if (!response.ok) {
          throw new Error(`HTTP Error! status: ${response.status}`)
        }

        const data = await response.json()
        const currentTotals = calculateTotals() // Get current totals

        const formattedPayments = processInvoiceData(
          data.data,
          state.data.plantId,
          invoiceDetails,
          currentTotals,
          energyValu,
          mainEnergy
        )

        setOutstandingPayments(formattedPayments)
      } catch (error) {
        console.error(error)
      }
    }

    allInvoice()
  }, [
    invoiceDate,
    mainEnergy,
    mainTariff,
    deemedEnergy,
    deemedTariff,
    energyValu,
  ]) // Added energyValu to dependencies

  useEffect(() => {
    const summary = []
    Object.entries(faultEvents).forEach(([key, value]) => {
      if (value > 0) {
        summary.push({
          faultType: key.replace(/([A-Z])/g, ' $1').trim(),
          duration: '0:00',
          unitLoss: value,
        })
      }
    })
    setFaultSummary(summary)
  }, [faultEvents])

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </div>
    )
  }

  const totals = calculateTotals()

  // Handle energy value changes
  const handleEnergyValueChange = (newValue) => {
    setEnergyValu(newValue)
    setMainEnergy(newValue)
    setEnergyValu(newValue)
  }

  const handleDateValueChange = (newValue) => {
    const normalized = dayjs(newValue).format('YYYY-MM-DD')
    console.log('📅 Invoice date changed to:', normalized)
    console.log('🗓️ Selected billing month:', invoiceDate)
    setFirstDate(normalized)
    // Update default due date when invoice date changes
    const terms = Number(state?.data?.paymentTermsDays) || 7
    const nextDue = dayjs(normalized).add(terms, 'day').format('YYYY-MM-DD')
    setDueDate(nextDue)
  }

  const handleDueDateChange = (newValue) => {
    setDueDate(newValue)
  }

  // ADD THIS FUNCTION - Handle deemed generation changes
  const handleDeemedGenerationChange = (newValue) => {
    setDeemedGener(newValue)
  }

  // ADD THIS FUNCTION - Handle save operation
  const handleSave = async () => {
    setProcessingButton('save') // Set processing state
    try {
      setSaveStatus({
        open: true,
        message: 'Saving invoice...',
        severity: 'info',
      })

      // Set flags to prevent state interference
      setIsSaving(true)
      setIsUpdatingFromDB(true)

      // Handle the database operations
      const invoiceData = await fetchInvoicesByPlantId(true, true) // Prevent state updates

      // Update or create the invoice
      if (invoiceData?.data?.length > 0) {
        await updateInvoiceDetails()
      } else {
        await createInvoiceDetails()
      }

      // Update UI with latest data after save
      setTimeout(async () => {
        setIsUpdatingFromDB(false)
        const updatedInvoiceData = await fetchInvoicesByPlantId(true, false)

        // Update UI with database values
        const newDeemedEnergyValue = updatedInvoiceData?.data?.find(
          (item) => item.deemedEnergy !== undefined
        )?.deemedEnergy
        const newDeemedTariffValue = updatedInvoiceData?.data?.find(
          (item) => item.deemedTariff !== undefined
        )?.deemedTariff
        const newDeemedGenerationValue = updatedInvoiceData?.data?.find(
          (item) => item.deemedGeneration !== undefined
        )?.deemedGeneration
        const newPaymentStatus = updatedInvoiceData?.data?.find(
          (item) => item.paymentStatus !== undefined
        )?.paymentStatus

        if (newDeemedEnergyValue !== undefined) {
          setDeemedEnergy(newDeemedEnergyValue)
        }
        if (newDeemedTariffValue !== undefined) {
          setDeemedTariff(newDeemedTariffValue)
        }
        if (newDeemedGenerationValue !== undefined) {
          setDeemedGener(parseFloat(newDeemedGenerationValue).toFixed(2))
        }
        if (newPaymentStatus !== undefined) {
          setPaymentStatus(newPaymentStatus)
          setDbPaymentStatus(newPaymentStatus)
        }
      }, 500)

      // Check if invoice exists to decide between modal or snackbar
      if (invoiceDetails && invoiceDetails.length > 0) {
        // Show modal for existing invoice
        setInvoiceModal({
          open: true,
          type: 'success',
          title: 'Invoice Updated',
          message: 'Your invoice has been updated successfully.',
        })
      } else {
        // Show snackbar for new invoice
        setSaveStatus({
          open: true,
          message: 'Invoice saved successfully!',
          severity: 'success',
        })
      }
    } catch (error) {
      console.error('Error saving invoice:', error)
      setSaveStatus({
        open: true,
        message: 'Error saving invoice',
        severity: 'error',
      })
    } finally {
      setProcessingButton(null)
      setTimeout(() => {
        setIsSaving(false)
      }, 1000)
    }
  }

  // ADD THIS FUNCTION - Handle download operation
  const handleDownload = async () => {
    setProcessingButton('download') // Set processing state
    try {
      setSaveStatus({
        open: true,
        message: 'Generating PDF...',
        severity: 'info',
      })

      // Store current values for PDF generation
      const preservedValues = {
        energyValu,
        deemedEnergy,
        deemedTariff,
        mainTariff,
        firstDate,
        deemedGener,
      }

      // Generate PDF with current values
      await generatePDFWithValues(preservedValues)

      setSaveStatus({
        open: true,
        message: 'Download completed successfully!',
        severity: 'success',
      })
    } catch (error) {
      console.error('Error downloading invoice:', error)
      setSaveStatus({
        open: true,
        message: 'Error generating PDF',
        severity: 'error',
      })
    } finally {
      setProcessingButton(null)
    }
  }

  const handleExportToZoho = () => {
    setExportZohoDialogOpen(true)
  }

  const handleConfirmExportToZoho = async () => {
    // setIsDownloading(true)
    setProcessingButton('exportZoho')
    setExportZohoDialogOpen(false)

    try {
      // Fetch latest invoice data
      await fetchInvoicesByPlantId()

      const exportResult = await exportToZoho({
        invoiceDetails,
        state,
        invoiceDate,
        totals: calculateTotals(),
        energyValu,
        mainEnergy,
        mainTariff,
        deemedEnergy,
        deemedTariff,
        omAmounts,
        zohoState,
        zohoinvoicenumber,
      })

      if (exportResult.success) {
        setEmailStatus({
          open: true,
          message: exportResult.message,
          severity: 'success',
        })
        // IMPORTANT: Refresh invoice data to get the updated invoice number from MongoDB
        await fetchInvoicesByPlantId()

        // Also refresh the Zoho invoice number to show the stored one
        await fetchZohoInvoicesByPlantId()

        // Update the zohoConnected status
        setZohoConnected(true)
      } else {
        setEmailStatus({
          open: true,
          message: exportResult.message,
          severity: 'error',
        })
      }
    } catch (error) {
      setEmailStatus({
        open: true,
        message: `Unexpected error: ${error.message}`,
        severity: 'error',
      })
    } finally {
      // setIsDownloading(false)
      setProcessingButton(null) // Reset processing state
    }
  }

  const invoiceTableProps = {
    energyValu,
    setEnergyValu: handleEnergyValueChange,
    mainEnergy,
    setMainEnergy: handleEnergyValueChange,
    totals: calculateTotals(),
    setMainTariff,
    mainTariff,
    state,
    invoiceDate,
    handleEditClick,
    energyValue,
    deemedEnergy,
    setDeemedEnergy,
    deemedTariff,
    setDeemedTariff,
    deemedGeneration,
    deemedGener, // ADD THIS LINE - Pass deemedGener to InvoiceTable
    setDeemedGener: handleDeemedGenerationChange, // ADD THIS LINE - Pass the handler
    omAmounts,
    setOmAmounts,
    months,
    firstDate,
    setFirstDate: handleDateValueChange,
    dueDate,
    setDueDate: handleDueDateChange,
    invoiceDetails,
    zohoState,
    zohoinvoicenumber,
    billingRecord,
  }

  return (
    <div
      className={`no-print ${classes.root}`}
      style={{ marginBottom: '20px' }}
    >
      {billingRecordError && (
          <MuiAlert 
            severity="error" 
            style={{ marginBottom: '20px' }}
            onClose={() => setBillingRecordError(null)}
          >
            {billingRecordError}
          </MuiAlert>
        )}

      <ActionButtons
        onEmailTeam={() => handleEmailButtonClick('team')}
        onEmailCustomer={() => handleEmailButtonClick('customer')}
        onSave={handleSave}
        onDownload={handleDownload}
        onExportToZoho={handleExportToZoho}
        // isDownloading={isDownloading}
        processingButton={processingButton} // Pass the processing state
        zohoConnected={zohoConnected}
        paymentStatus={paymentStatus}
        dbPaymentStatus={dbPaymentStatus} // Pass the saved DB status
        onPaymentStatusChange={setPaymentStatus}
        invoiceExists={invoiceDetails && invoiceDetails.length > 0} // Pass invoice existence check
        sentDate={
          invoiceDetails && invoiceDetails.length > 0
            ? invoiceDetails[0].sentDate
            : null
        } // Pass sent date
        emailSent={
          invoiceDetails && invoiceDetails.length > 0
            ? invoiceDetails[0].emailSent
            : false
        } // Pass email sent status
        autoGenerate={autoGenerate}
        onAutoGenerateChange={handleAutoReminderClick}
      />
      <div style={{ width: '100%', overflowX: 'auto', whiteSpace: 'nowrap' }}>
        <div>
          <InvoiceTable {...invoiceTableProps} />

          {/* <div className={classes.containerStyle} id="annexurePage">
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <img
                style={{ height: 70, width: 150 }}
                src={LogoP1}
                alt="DE logo1"
              />
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
                    {zohoState?.organizationName || 'DE Solar Assets Series 2 LLP'}
                  </div>
                </div>
            </div>

            <div className={classes.containerStyle}>
              <div className={classes.Boldstyle}>Annexure 1 : Fault Events</div>
              <div style={{ marginTop: '20px' }}>
                Summary of Fault Events for the month {months[CurrentMonth]}{' '}
                {dayjs(invoiceDate).format('YYYY')}
                <FaultEventsTable
                  classes={classes}
                  faultEvents={faultEvents}
                  handleFaultEventChange={handleFaultEventChange}
                  totals={totals}
                  accountableFailure={accountableFailure}
                  handleAccountableFailureChange={
                    handleAccountableFailureChange
                  }
                />
                <div style={{ marginTop: '20px' }}>
                  <FaultSummaryTable
                    classes={classes}
                    faultSummary={faultSummary}
                    invoiceDate={invoiceDate}
                  />
                </div>
              </div>

              <OutstandingPaymentsTable
                classes={classes}
                outstandingPayments={outstandingPayments}
                editingPaymentId={editingPaymentId}
                handlePaymentChange={handlePaymentChange}
                handleEditPayment={handleEditPayment}
                handleSavePayment={handleSavePayment}
                handleCancelPayment={handleCancelPayment}
                handleDeletePayment={handleDeletePayment}
                handleAddPayment={handleAddPayment}
                printMode={printMode}
                totals={totals}
                state={state}
                FetchCurrency={FetchCurrency}
              />
            </div>
          </div> */}
        </div>
      </div>
      <EmailDialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
        emailType={emailType}
        onConfirm={handleConfirmEmail}
        toEmails={emailDialogData?.toEmails}
        ccEmails={emailDialogData?.ccEmails}
        isLoading={emailDialogData?.isLoading}
        error={emailDialogData?.error}
        isSending={
          (processingButton === 'emailTeam' && emailType === 'team') ||
          (processingButton === 'emailCustomer' && emailType === 'customer')
        }
      />

      <AutoReminderDialog
        open={autoReminderDialogOpen}
        onClose={() => setAutoReminderDialogOpen(false)}
        onConfirm={handleConfirmAutoReminder}
        currentStatus={autoGenerate}
      />

      <ExportZohoDialog
        open={exportZohoDialogOpen}
        onClose={() => setExportZohoDialogOpen(false)}
        onConfirm={handleConfirmExportToZoho}
        plantName={state?.data?.plantName}
        invoiceNumber={invoiceNumber || zohoinvoicenumber}
      />

      <Snackbar
        open={emailStatus.open}
        autoHideDuration={6000}
        onClose={() => setEmailStatus((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          severity={emailStatus.severity}
          sx={{ width: '100%' }}
          onClose={() => setEmailStatus((prev) => ({ ...prev, open: false }))}
        >
          {emailStatus.message}
        </Alert>
      </Snackbar>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="info"
          sx={{ width: '100%' }}
        >
          Please edit in plant details dashboard.
        </Alert>
      </Snackbar>

      <Snackbar
        open={saveStatus.open}
        autoHideDuration={6000}
        onClose={() => setSaveStatus({ ...saveStatus, open: false })}
      >
        <Alert severity={saveStatus.severity} sx={{ width: '100%' }}>
          {saveStatus.message}
        </Alert>
      </Snackbar>



      {/* Invoice Modal Popup - Center of Page */}
      {invoiceModal.open && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1500,
            animation: 'fadeIn 0.3s ease-in-out',
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              padding: '32px',
              maxWidth: '420px',
              width: '90%',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
              animation: 'slideUp 0.3s ease-in-out',
            }}
          >
            {/* Header with close button */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: '16px',
              }}
            >
              <div style={{ flex: 1 }}>
                {/* Icon and Title */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: invoiceModal.type === 'success' ? '#e8f5e9' : '#fff3e0',
                      color: invoiceModal.type === 'success' ? '#4caf50' : '#ff9800',
                      fontSize: '24px',
                      fontWeight: 'bold',
                    }}
                  >
                    {invoiceModal.type === 'success' ? '✓' : '!'}
                  </div>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: '18px',
                      fontWeight: '600',
                      color: '#333',
                    }}
                  >
                    {invoiceModal.title}
                  </h3>
                </div>
              </div>
              {/* Close Button */}
              <button
                onClick={() => setInvoiceModal({ ...invoiceModal, open: false })}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '28px',
                  cursor: 'pointer',
                  color: '#999',
                  padding: '0',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
                title="Close modal"
              >
                ×
              </button>
            </div>

            {/* Message */}
            <p
              style={{
                fontSize: '14px',
                color: '#666',
                lineHeight: '1.6',
                margin: '0 0 24px 0',
              }}
            >
              {invoiceModal.message}
            </p>

            {/* Action Button */}
            <button
              onClick={() => setInvoiceModal({ ...invoiceModal, open: false })}
              style={{
                width: '100%',
                padding: '10px 16px',
                backgroundColor: invoiceModal.type === 'success' ? '#4caf50' : '#ff9800',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = invoiceModal.type === 'success' ? '#45a049' : '#e68900'
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = invoiceModal.type === 'success' ? '#4caf50' : '#ff9800'
              }}
            >
              Close
            </button>
          </div>

          <style>{`
            @keyframes fadeIn {
              from {
                opacity: 0;
              }
              to {
                opacity: 1;
              }
            }
            @keyframes slideUp {
              from {
                transform: translateY(20px);
                opacity: 0;
              }
              to {
                transform: translateY(0);
                opacity: 1;
              }
            }
          `}</style>
        </div>
      )}
    </div>
  )
}

export default InvoiceBill
